// eslint-disable-next-line import/no-anonymous-default-export
export default {
    //Ofício por Situação
    LIXEIRA: 'LIXEIRA',
    EM_EDICAO: 'EM_EDICAO',
    EM_REVISAO: 'EM_REVISAO',
    EM_CORRECAO: 'EM_CORRECAO',
    EM_REVISAO_OFICIAL: 'EM_REVISAO_OFICIAL',
    PARA_ASSINATURA: 'PARA_ASSINATURA',
    PARA_ASSINATURA_PRESIDENTE: 'PARA_ASSINATURA_PRESIDENTE',
    AGUARDANDO_RECEBIMENTO_PROCESSO_SEI: 'AGUARDANDO_RECEBIMENTO_PROCESSO_SEI',
    PARA_ENVIO_DE_OFICIO: 'PARA_ENVIO_DE_OFICIO',
    PENDENTE_DE_RECIBO: 'PENDENTE_DE_RECIBO',
    
    //Ofícios Enviados
    ENTREGUES: 'ENTREGUES',
    NAO_ENTREGUES: 'NAO_ENTREGUES',
    COM_CERTIDAO: 'COM_CERTIDAO',
    CERTIDAO_PARA_ASSINATURA: 'CERTIDAO_PARA_ASSINATURA',
    PARA_JUNTADA: 'PARA_JUNTADA',
    CONCLUIDOS: 'CONCLUIDOS',
    
    //Protocolo de Ofícios para Envio
    PROTOCOLOS_PENDENTES_DE_ENVIO: 'PROTOCOLOS_PENDENTES_DE_ENVIO',
    PROTOCOLOS_PENDENTES_DE_RECIBO: 'PROTOCOLOS_PENDENTES_DE_RECIBO',
    PROTOCOLOS_PARA_CORRECAO_DE_RECIBO: 'PROTOCOLOS_PARA_CORRECAO_DE_RECIBO',
}